<template>
  <div>
    <h1>Outdoor Page</h1>
    <p>Content for Outdoor.</p>
  </div>
</template>

<script>
export default {
  name: 'Outdoor'
}
</script>

<style>
/* 添加样式 */
</style>
